import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useCommentPostAction } from '../../../CommentEditor.editor_v3/hooks/useCommentPostAction';
import { useCommentCancelAction } from '../../../CommentEditor.editor_v3/hooks/useCommentCancelAction';
import { CommentEditorContext } from '../../../CommentEditor.editor_v3/context';
import CommentEditor from '../../../CommentEditor.editor_v3';
import LoadingPlaceholder from '../LoadingPlaceholder';
import LazyPlaceholder from '../LazyPlaceholder';
import CommentBoxFooter from '../CommentBoxFooter';
import { useEditorContext } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import s from './CommentBoxEditor.scss';
/** The core of our comment box. This is a `<CommentEditor />` with a footer and a loading indicator */ const CommentBoxEditor = (_param)=>{
    var { className, footerClassName, nc, onCancel, onPost, onEditorReady } = _param, restProps = _object_without_properties(_param, [
        "className",
        "footerClassName",
        "nc",
        "onCancel",
        "onPost",
        "onEditorReady"
    ]);
    const { isBusy, commentableItemId, commentableType, isExpanded } = useContext(CommentEditorContext);
    const { isLoadingTriggered } = useContext(LoadableComponentContext);
    const postComment = useCommentPostAction({
        messageId: nc === null || nc === void 0 ? void 0 : nc.messageId,
        folderId: nc === null || nc === void 0 ? void 0 : nc.folderId,
        shouldDeleteMessage: nc === null || nc === void 0 ? void 0 : nc.shouldDeleteMessage,
        onPost
    });
    const cancelComment = useCommentCancelAction({
        onCancel
    });
    // Listen for mod+enter submit events coming from the editor
    const editor = useEditorContext();
    editor === null || editor === void 0 ? void 0 : editor.on('do-submit', ()=>{
        postComment();
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isExpanded && s['expanded'], className)
    }, isBusy && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['loading']
    }), !isLoadingTriggered && /*#__PURE__*/ React.createElement(LazyPlaceholder, null), isLoadingTriggered && /*#__PURE__*/ React.createElement(CommentEditor, _object_spread({
        className: classnames(s['commentbox-editor'], isExpanded && s['expanded']),
        loadingIndicator: /*#__PURE__*/ React.createElement(LoadingPlaceholder, null),
        onKeyboardSubmit: postComment,
        onEditorReady: onEditorReady
    }, restProps)), isLoadingTriggered && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            itemid: typeof commentableItemId === 'string' ? parseInt(commentableItemId) : commentableItemId,
            typeid: commentableType
        }
    }, /*#__PURE__*/ React.createElement(CommentBoxFooter, {
        onCancel: cancelComment,
        onPost: postComment,
        className: classnames(s['commentbox-footer'], footerClassName)
    })), nc && nc.postfix);
};
CommentBoxEditor.displayName = 'CommentBoxEditor';
export default CommentBoxEditor;

//# sourceMappingURL=CommentBoxEditor.js.map